import Cookies from 'js-cookie'

const TokenKey = 'zus_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token:any) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLocalStorage(key:string){
  return localStorage.getItem(key)
}

export function setLocalStorage(key:string,val:any){
  return localStorage.setItem(key,JSON.stringify(val))
}

export function removeLocalStorage(key:string){
  return localStorage.removeItem(key)
}
